import HatsWebSdk from '@bfe/trade-base-hatsweb';
import { ls } from '@sfe/bone-cache';
import { ROUTE_CHOSEN_STORAGE_KEY } from '@/config/env';

const initHatsWeb = () => {
    const selectedStorageDomain = ls.get(ROUTE_CHOSEN_STORAGE_KEY);
    const autoCdn = !selectedStorageDomain || selectedStorageDomain === 'auto';
    // console.log("autoCdn", autoCdn)

    HatsWebSdk({
        rt: 'trade-spot',
        includeHttpRegexp: [
            // 用户信息
            '/v2/private/user/profile',
            '/user/private/member/info',
            // 登出接口
            '/logout',
            // 币种收藏
            '/v3/private/user/member/pref-setting',
            '/v3/private/user/member/preferences',
            // 法币折合汇率
            '/api/exchange-rate',
            // 交易所通知
            '/v3/config/banner',
            // 币种配置
            '/v3/private/cht/asset-common/coin-config',
            '/v3/private/instrument/dynamic-symbol',
            // 币种清单
            '/spot/api/basic/symbol_list_v3',
            '/spot/api/basic/symbol_list_all',
            '/spot/api/basic/symbol_list_v2',
            // kline 信息
            '/spot/api/quote/v2/klines',
            // 币种详情
            '/spot/api/token/get/detail',
            // 币种是否可见（上线）
            '/spot/api/basic/query_notice_visible_symbol',
            // 用户资产
            '/spot/api/asset/get',
            '/spot/api/v1/asset/get_available',
            // 用户订单
            '/spot/api/order/',
            // bit免责声明
            '/spot/s_api/user/trade_hint',
            // 可用区币种余额
            '/spot/api/basic/innovation/remain_amount',
            // LT 代币
            '/spot/api/lt/',
            // 杠杆交易
            '/spot/api/crossmargin/',
            '/spot/api/v1/asset/cross_margin/get_balance',
            '/spot/api/order/cross/create_order',
            '/spot/api/order/create',
            // UTA钱包
            '/siteapi/unified/private/spot-walletbalance',
            // deadpool
            '/v3/config/web',
            // bot
            '/s1/bot/grid/v1/query-grid-list',
            '/s1/bot/grid/v1/list-symbol-info',
            '/s1/bot/grid/v1/query-available-balance',
            // 通知
            '/notification-site/v2/private/message/unread_cnt',
            '/notification-site/v2/private/message/list',
            '/notification-site/v1/public/adabot/get_adabot_push',
            // 活动
            '/spot/api/activity/v2/home',
        ],
        autoCdn,
    });
};

export default initHatsWeb;
